/* eslint-disable */
const ruleConfig = [
  {
    value: '{"label":"闪现","value":"spark","rule_type":"OR","rules":[{"key":"$$.window.location.search","op":"contain","value":"via=spark_"},{"key":"$$.window.navigator.userAgent","op":"contain","value":"com.tencent.gamecommunity"}]}',
    label: '闪现',
  },
  {
    value: '{"label":"心悦俱乐部","value":"tgclub","rule_type":"OR","rules":[{"key":"$$.window.navigator.userAgent","op":"contain","value":"tgclub"},{"key":"$$.window.location.search","op":"contain","value":"via=vip_"}]}',
    label: '心悦俱乐部',
  },
  {
    value: '{"label":"超核","value":"supercore","rule_type":"AND","rules":[{"key":"$$.window.location.search","op":"contain","value":"via=svip_"}]}',
    label: '超核',
  },
  // 助手类端内
  {
    value: '{"label":"腾讯帮帮","value":"bb","rule_type":"AND","rules":[{"key":"$$.window.navigator.userAgent","op":"contain","value":"GameHelper"}]}',
    label: '助手类登录',
  },
  {
    value: '{"label":"知几","value":"gbot","rule_type":"AND","rules":[{"key":"$$.window.location.search","op":"contain","value":"via=gbot_"}]}',
    label: '知几',
  },
];

export default ruleConfig;
export const AstTgclub = 'tgclub';
export const AstSuperCore = 'supercore';
export const AstSpark = 'spark';
